import React, { Fragment } from 'react';
import { FormattedMessage } from 'react-intl';

import { configs } from '@constants/configs/configs';
import ModalHeader from '@common-components/headers/ModalHeader';

const AppStatusClosedModal = props => {
    const { routes } = configs;

    const {
        modalHeaderProps,
        actions: {
            hideModal
        }
    } = props;

    const handleCloseModal = () => hideModal();

    return (
        <Fragment>
            <div className="gi-modal__header__head">
                <ModalHeader {...modalHeaderProps } />
            </div>
            <div className="gi-modal__body" id={`${modalHeaderProps.modalId}_body`}>
                <p>
                    <FormattedMessage id="appstatus.closed.warning"
                        values={{
                            dashboardLink: (<a
                                href={routes.INDPORTAL}>
                                <FormattedMessage
                                    id="dashboard.back"/>
                            </a>),
                            strong: chunks => <strong>{chunks}</strong>
                        }}
                    />
                </p>
            </div>
            <div className="gi-modal__controls">
                <button className="usa-button usa-button--outline gi-button gi-button__outline" onClick={handleCloseModal}>
                    <FormattedMessage id="dashboard.ok"/>
                </button>
            </div>
        </Fragment>
    );
};

export default AppStatusClosedModal;
